import BaseAPIHelper from './BaseAPIHelper';

export const requestFamilyBookingList = ({ userId, booking_access, booking_refresh }) => {
    const link = `/customers/${userId}/family_booking_list`;
    const input = { access: booking_access, refresh: booking_refresh };
    return BaseAPIHelper.post({ link, input });
};